import { observable, action, computed } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import { notification } from 'antd';
import moment from 'moment';

export default class GoodsInfoStore {
  constructor(root) {
    this.root = root;
  }

  //----------------------------------
  /* Mainstore에서 세션만료 처리하기위해 */
  @observable
  _commonStoreInfo = null;

  @computed
  get commonStoreInfo() {
    return this._commonStoreInfo;
  }

  @action
  setCommonStoreInfo = (storeInfo) => {
    this._commonStoreInfo = storeInfo;
  };
  //----------------------------------
  /* 화면 변경 목록, 상세보기, 수정, 추가 */
  @observable
  _viewMode = 'list';

  @computed
  get viewMode() {
    return this._viewMode;
  }

  @action
  onViewMode = (mode) => {
    // list, detail, add, mod
    this._viewMode = mode;
    if (mode === 'add') {
      this._detailData = null;
    }
  };
  //----------------------------------
  /* 검색조건 */
  @observable 
  _valCondition = {
    gdNm: '',
    pGdCd: '',
    pageIdx: 1,
    recordCountPerPage: 10,

    strDate: moment().subtract(10, 'day').format('YYYY-MM-DD'),
    endDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
  };

  @computed
  get valCondition() {
    return this._valCondition;
  }

  @action
  onChangValue = (dataNm, dataVal) => {
    this._valCondition = {
      ...this._valCondition,
      [dataNm]: dataVal
    };
  };
  //----------------------------------
  /* 상세데이터 */
  @observable
  _detailData = null;

  @computed
  get detailData() {
    return this._detailData;
  }

  //----------------------------------
  @observable 
  _goodsList = [];

  @computed
  get goodsList() {
    return this._goodsList;
  }

  @observable
  _pageInfo = null;

  @computed
  get pageInfo() {
    return this._pageInfo;
  }
  //----------------------------------
  @action
  onClear = () => {
    this._viewMode = 'list';

    this._goodsList = [];
    this._pageInfo = null;
    this._detailData = null;
    this._valCondition = {
      gdNm: '',
      pGdCd: '',
      pageIdx: 1,
      recordCountPerPage: 10,

      strDate: moment().subtract(10, 'day').format('YYYY-MM-DD'),
      endDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
    };
  };

  //-----------------------------------------------------------------------//
  @action
  disGoodsList = async (pageIdx, recordCountPerPage) => {
    if (pageIdx !== undefined && pageIdx !== null && this._valCondition.pageIdx !== pageIdx) {
      this._valCondition.pageIdx = pageIdx;
    }
    if (recordCountPerPage !== undefined && recordCountPerPage !== null && this._valCondition.recordCountPerPage !== recordCountPerPage) {
      this._valCondition.recordCountPerPage = recordCountPerPage;
    }
    
    let addition = new Addition();
    addition.setCmdName('DIS-GOODS-LIST');
    addition.setPageYn('Y');
    addition.setPageIndex(this._valCondition.pageIdx);
    addition.setRecordCountPerPage(this._valCondition.recordCountPerPage);

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'gdNm', paraValue: this._valCondition.gdNm});
    reqInputMsg.addParam({paraName: 'pGdCd', paraValue: this._valCondition.pGdCd});

    return await callCmd(reqInputMsg, 'goodsInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._goodsList = res.result;
          this._pageInfo = res.addition;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._goodsList = [];
          this._pageInfo = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._goodsList = [];
        this._pageInfo = null;
        console.log('error', error);
      });
  };

  @action
  disGoodsDetail = async (data) => {
    let addition = new Addition();
    addition.setCmdName('DIS-GOODS-DETAIL');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'gdCd', paraValue: data.gdCd});
    
    return await callCmd(reqInputMsg, 'goodsInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result.length > 0) {
            this._detailData = {
              ...data,
              ...res.result[0]
            };
            this._viewMode = 'detail';
          } else {
            notification.error({placement: 'bottomLeft', message: `상세보기가 실패하였습니다.`, duration: 2});
            this._detailData = null;
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._detailData = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._detailData = null;
        console.log('error', error);
      });
  };

  @action
  addGoodsInfo = async (data) => {
    if (data.gdSizeList !== undefined && data.gdSizeList !== null && data.gdSizeList.length > 0) {
      const newData = [...data.gdSizeList];
      let vArr = [];
      newData.map((item,idx)=>{return (
        (item.stSize !== '') &&
          (vArr.push({
            ...item, 
            stOrder: idx,
            stCnt: item.stCnt === '' ? 0 : item.stCnt
          }))
      )});
      data.gdSizeList = vArr;
    }
    
    // data를 name value로 수정
    let paramData = [];
    Object.keys(data).map((key)=>{return (
      paramData.push({
        paraName: key, paraValue: data[key]
      })
    )});

    // console.log(paramData);

    let addition = new Addition();
    addition.setCmdName('ADD-GOODS-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.setParamList(paramData);
    
    return await callCmd(reqInputMsg, 'goodsInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`등록이 성공하였습니다.`, duration: 2});
            this._viewMode = 'list';
            this.disGoodsList();
          } else {
            notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  @action
  modGoodsInfo = async (data) => {
    if (data.gdSizeList !== undefined && data.gdSizeList !== null && data.gdSizeList.length > 0) {
      const newData = [...data.gdSizeList];
      let vArr = [];
      newData.map((item,idx)=>{return (
        (item.stSize !== '') &&
          (vArr.push({
            ...item, 
            stOrder: idx,
            stCnt: item.stCnt === '' ? 0 : item.stCnt
          }))
      )});
      data.gdSizeList = vArr;
    }
    // console.log(data.gdSizeList);

    // data를 name value로 수정
    let paramData = [];
    Object.keys(data).map((key)=>{return (
      paramData.push({
        paraName: key, paraValue: data[key]
      })
    )});

    //console.log('paramData', paramData);

    let addition = new Addition();
    addition.setCmdName('MOD-GOODS-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.setParamList(paramData);
    
    return await callCmd(reqInputMsg, 'goodsInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`수정이 성공하였습니다.`, duration: 2});
            this._viewMode = 'detail';
            this.disGoodsDetail(data);
            this.disGoodsList();
          } else {
            notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });

  };  
}
  
